import { Model } from "vue-mc";

export class PlantillaCorreo extends Model {
  defaults() {
    return {
      clave: ""
      , descripcion: ""
      , remitente: ""
      , multiListPerfilesDestinatarios: []
      , destinatariosOpcionales: ""
      , cc: ""
      , cco: ""
      , asunto: ""
      , cuerpo: ""
      , status: true
      , version: 0
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , remitente: (remitente) => remitente
      , multiListPerfilesDestinatarios: (multiListPerfilesDestinatarios) => multiListPerfilesDestinatarios
      , destinatariosOpcionales: (destinatariosOpcionales) => destinatariosOpcionales
      , cc: (cc) => cc
      , cco: (cco) => cco
      , asunto: (asunto) => asunto
      , cuerpo: (cuerpo) => cuerpo
      , status: (status) => status
      , version: (version) => version
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/generales/plantilla-correo.js